<template>
  <div
    :class="{ 'calendar-mobile': isMobile, 'calendar-external-drop-target': externalDropHighlighted }"
    @dragenter.prevent="handleExternalDragEnter"
    @dragover.prevent="handleExternalDragOver"
    @dragleave="handleExternalDragLeave"
  >


    <v-dialog v-model="dialogReccur" width="500" @click:outside="cancelReccur">
        <v-card>
            <v-card-title>
                Modifier l'évènement périodique
            </v-card-title>

            <v-card-text v-if="eventReccur">

      <v-radio-group
        v-model="choiceReccur"
        :mandatory="true"
      >
        <v-radio
          label="Cet événement seulement"
          value="single"
          class="mr-4"
        />
        <v-radio
          label="Cet événement et tous les suivants"
          value="future"
          class="mr-4"
        />
        <v-radio
        v-if="recurrForAll"
          label="Tous les événements"
          value="all"
        />
      </v-radio-group>
            </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="cancelReccur">Annuler</v-btn>
      <v-btn color="primary" @click="applyChangeReccur">Appliquer</v-btn>
    </v-card-actions>
        </v-card>
    </v-dialog>


        <v-row>

                <v-col class="col-12 col-md-2 mx-auto">
            <datepicker
            :valField="moment(calendarDate).format('YYYY-MM-DD')"
            :item="{value:'ee',defaultprops:{show:true,iconlr:'prepend',iconinout:'in',iconmdi:'mdi-calendar'}}"
            :change="(item,model) => { if(!firstLoad) calendarApi.gotoDate( model ); $router.push({ query: { ...$route.query, date: model } }).catch(() =>{}); }"
            />
            </v-col>
        </v-row>

<v-progress-linear
:indeterminate="onLoading"
></v-progress-linear>
<v-progress-linear v-if="enrichmentLoading" indeterminate height="2" />
<div v-if="enrichmentError" class="text-caption warning--text">{{ enrichmentError }}</div>

    <FullCalendar
    ref="fullCalendar"
    :options="calendarOptions"
    >

    <template v-slot:eventContent='arg' >

        <v-tooltip right :min-width="arg.event.extendedProps.tooltipMinWidth" :disabled="isDropOrResize">
        <template v-slot:activator="{ on, attrs }" >

                <div class='fc-event-main-frame' v-bind="attrs" v-on="on" style="overflow:hidden;" >
                    <v-expand-transition>
                        <div
                        v-if="attrs['aria-expanded']=='true' && isDropOrResize===false"
                        class="grey lighten-3"
                        style="height: 30px;"
                        >
                            <span v-for="(action,i) in arg.event.extendedProps.actions" :key="i" class="chat-share-host d-inline-flex align-center">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small >
                                        <v-icon v-bind="attrs" @click="callAction(action,arg.event.extendedProps.otherfields)" v-on="on">{{action.icon}}</v-icon>
                                        </v-btn>
                                </template>
                                <span>{{action.name}}</span>
                        </v-tooltip>
                        <rights-indicator :checks="actionInspectionChecks(action)" :label="action.name" />
                        <ChatShareMenu :modal-key="modalKey" :reference="shareActionReference(arg.event.extendedProps.otherfields, action)" label="Partager cette action dans le chat" />
                        </span>

                        <v-btn icon small class="red--text" @click="delEvent(arg)"><v-icon right>mdi-delete-outline</v-icon></v-btn>
                        <rights-indicator :checks="tableInspectionChecks(table, ['delete'], arg.event.extendedProps.otherfields)" label="Supprimer cet événement" />

                        </div>
                    </v-expand-transition>
                    <div class='fc-event-time'  
                    :style="[
                        { 'background-color': arg.event.extendedProps.colortime }, arg.event.extendedProps.colorcontourtime ? { 'border': '2px solid '+arg.event.extendedProps.colorcontourtime } : ''
                        ]"
                        >
                        <span v-if="arg.event.extendedProps.initialEventID" class="float-right">
                            <v-icon x-small class="lime--text">mdi-timer-sync-outline</v-icon>
                        </span>
                    {{ arg.timeText }}</div>
                    <div class='fc-event-title-containur er'>
                        <div class='fc-event-title'>
                            <div>
                                <CPage
                                :pageTemplate="arg.event.extendedProps.encart"
                                :page="page"
                                :modal="modal"
                                :modalKey="modalKey"
                                :form="false"
                                hook="hook"
                                :customparams="arg.event.extendedProps.otherfields"
                                :mod="false"/>

                            </div>
                        </div>
                    </div>
                </div>

            </template>

            <CPage
            :pageTemplate="arg.event.extendedProps.tooltip"
            :page="page"
            :modal="modal"
            :modalKey="modalKey"
            :form="false"
            hook="hook"
            :customparams="arg.event.extendedProps.otherfields"
            :mod="false"/>

            </v-tooltip>
    </template>

    </FullCalendar>
    <!-- on ne met pas le template v-slot car les textes dépassent l'encart du RDV... -->
  </div>
</template>

<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

import datepicker from '@/components/fields/datePicker.vue'

import frLocale from '@fullcalendar/core/locales/fr';

import { client } from '../mixins';
import moduleEnrichmentsMixin from '../shared/moduleEnrichmentsMixin'
import {
  envelopeFromDataTransfer,
  hasEngineDragType,
  mappedDropFields,
  matchingConnection,
  normalizeEnvelope,
} from '../shared/dropReceiver';

export default {

  components: {
    FullCalendar, // make the <FullCalendar> tag available
    datepicker,
  },

  mixins : [client,moduleEnrichmentsMixin],

  data() {
    return {

        // permet d'&ttribuer les options du calendrier sur le premier chargement
        firstLoad : true,
        onLoading : false,
        fromThisModule : false,
        //représente l'instance de fullcalendar (voir dans le mounted)
        calendarApi : '',
        calendarDate : '',
        isMobile : false,
        initialHoursbar : null,
        initialView : 'timeGridWeek',
        defaultToolbarRight : 'dayGridMonth,timeGridWeek,timeGridDay',
        defaultToolbarLeft : 'prev,next today',
        defaultToolbarCenter : 'title',
        syncInterval : null,

        //pour la fonction reccurennce
        dialogReccur : false,
        //choix de l'utilisateur
        choiceReccur : '',
        //event selectionné
        eventReccur : {},
        //permet de savoir ce qu'il fait après le choix pour la recurrence
        typeActionReccur : '',

        params : [],
        table : '',

        // permet de définir si ce module est intégré dans une page form (nouvelle:newform ou en mode édition:editform), ou une page classique : page
        typePage : (!this.$store.getters['listForm'](this.modalKey)) ? 'page' : this.$store.getters['listForm'](this.modalKey).typeform ,

        args : [],
        searchField : false,
        isDropOrResize : false,
        externalDropHighlighted: false,
        pendingSourceModuleReload: null,

        defaultFilter : false,
        initialDate : false,
        clickAction : false,

      calendarOptions: {

        plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        initialView: 'timeGridWeek',
        hiddenDays : [],
        editable: true,
        // Les calendriers historiques restent fermés aux sources externes tant
        // qu'au moins une connexion de drop n'est pas explicitement activée.
        droppable: false,
        selectable: true,
        eventDisplay: "block",
        selectMirror: true,
        dayMaxEvents: true,
        searchmodule: [],
        slotMinTime : '05:00:00',
        slotMaxTime : '22:00:00',
        height : 'auto',
        parentModal : this.$store.getters.modalShowParams({ type: 'current', val: this.modalKey })['parent'],
        titleFormat : { year: 'numeric', month: 'long', day: 'numeric' },

        eventSources : [
            {
                events : (date, callback) => {
                    this.cancelModuleEnrichments()
                    const generation = this._calendarLoadGeneration = (this._calendarLoadGeneration || 0) + 1
                    this.onLoading = true
                this.API({type:'post', url:'displaymodule', params:{params:this.args,id:this.idmodule,dates:date,querys:this.defaultFilter,firstload:this.firstLoad}}).then((resp) => {
                    if (generation !== this._calendarLoadGeneration) { callback([]); return }
                    let datas = resp.data;
                    if (datas.success === false) { callback([]); return }
                    // si premier chargement, on personnalise la vue en fonction des paramètres du module
if(this.firstLoad) {
                        this.params = datas.params
                        this.calendarOptions.droppable = !!(
                            datas.params.dropReceiver
                            && datas.params.dropReceiver.enabled
                            && Array.isArray(datas.params.dropReceiver.connections)
                            && datas.params.dropReceiver.connections.length
                        )
                        this.table = datas.table
                        this.searchmodule = datas.searchmodule
                        this.calendarOptions.hiddenDays = datas.params.vue.hiddenDays
                        this.calendarOptions.slotMinTime = datas.params.vue.minslot+":00:00";
                        this.calendarOptions.slotMaxTime = datas.params.vue.maxslot+":00:00";
                        this.initialHoursbar = datas.params.vue.hoursbar
                        const serverInitialView = datas.params.vue.initialView ? datas.params.vue.initialView : this.initialView
                        this.initialView = serverInitialView
                        if(!this.isMobile) {
                            this.calendarOptions.initialView = serverInitialView
                            if(serverInitialView && this.calendarApi.view.type !== serverInitialView) {
                                this.calendarApi.changeView(serverInitialView)
                            }
                        }

                        // creationd du champ de recherche :
                        this.searchField = datas.selectionliste

                        const headerToolbar = (this.calendarOptions && this.calendarOptions.headerToolbar) ? this.calendarOptions.headerToolbar : null
                        if(headerToolbar) {
                            this.defaultToolbarLeft = headerToolbar.left !== undefined ? headerToolbar.left : this.defaultToolbarLeft
                            this.defaultToolbarCenter = headerToolbar.center !== undefined ? headerToolbar.center : this.defaultToolbarCenter
                            this.defaultToolbarRight = headerToolbar.right !== undefined ? headerToolbar.right : this.defaultToolbarRight
                        }
                        this.firstLoad = false
                        this.applyResponsiveOptions()
                    }
                    // permet de rafraichir la date dans le datepicker
                    this.calendarDate = this.calendarApi.getDate()

                    // on met dans le callback, la liste des rdv en format json
                    callback(datas.events)
                    const rows = (datas.events || []).map(event => event.otherfields || {})
                    this.enrichModuleRows(rows, (datas.params || this.params).enrichmentsMetier || [], {
                        token: datas.enrichmentToken, params: this.args, querys: this.defaultFilter,
                    }).then(() => {
                        if (generation !== this._calendarLoadGeneration || !this.calendarApi) return
                        // FullCalendar reçoit une nouvelle propriété pour redessiner les visuels enrichis.
                        const currentEvents = this.calendarApi.getEvents()
                        ;(datas.events || []).forEach((event, index) => {
                            currentEvents.filter(current => String(current.id) === String(event.id)).forEach(current => current.setExtendedProp('otherfields', { ...rows[index] }))
                        })
                    })
                    this.onLoading = false

                }).catch(() => { if (generation === this._calendarLoadGeneration) callback([]) })
                  .finally(() => { if (generation === this._calendarLoadGeneration) this.onLoading = false })
                }
            },

        ],

        progressiveEventRendering : true,
        select: this.newRDV,
        eventClick: this.clickRDV,
        eventResize: this.endResize,
        eventDrop : this.Drop,
        eventReceive: this.receiveExternalEvent,
        eventDragStart : ()=>{ this.isDropOrResize = true},
        eventDragStop : ()=>{ this.isDropOrResize = false},
        eventResizeStart : ()=>{ this.isDropOrResize = true},
        eventResizeStop : ()=>{ this.isDropOrResize = false},
        locale: frLocale
      },
    }
  },

  computed : {
        //si on est dans une modal, si la query change, on reload les tableau qui sont liés à la recherche
    isNewFilterOnModal() {
      return (this.$store.getters.modalShowParams({ type: 'current', val: this.parentModal })) ? this.$store.getters.modalShowParams({ type: 'current', val: this.parentModal }).query : this.$route.query;
    },

    recurrForAll() {
      const ev = this.eventReccur;
      return (this.typeActionReccur !== 'drop' || (this.typeActionReccur == 'drop' && this.moment(ev.event.start).isSame(this.moment(ev.oldEvent.start), 'day')) );
    }
  },

  watch: {
    showMod: {
      // permet de rafraichir quand la modal de la page se ferme
      handler(val) {
        if (val.show === false && this.fromThisModule) {
            this.calendarApi.refetchEvents()
            this.reloadDropSourceModules(this.pendingSourceModuleReload)
            this.pendingSourceModuleReload = null
            this.fromThisModule = false;
        }
      },
      deep: true,
    },

        isNewFilterOnModal(val) {
            const previous = this.defaultFilter || {};
            const keys = new Set([...Object.keys(val || {}), ...Object.keys(previous)]);
            const changed = [...keys].some(key => (this.searchmodule || []).some(id => key.startsWith(id + '_'))
                && JSON.stringify((val || {})[key]) !== JSON.stringify(previous[key]));
            if(changed) {
                this.defaultFilter = {...val};
                this.calendarApi.refetchEvents();
            }
},

  },

    methods: {

        dropReceiver() {
            return (this.params && this.params.dropReceiver) || { enabled: false, connections: [] };
        },

        reloadDropSourceModules(preferredSourceModuleId = null) {
            const sourceIds = [];

            if (preferredSourceModuleId !== null && preferredSourceModuleId !== undefined && preferredSourceModuleId !== '') {
                sourceIds.push(preferredSourceModuleId);
            } else {
                const connections = this.dropReceiver().connections || [];
                connections.forEach(connection => {
                    const configuredSources = Array.isArray(connection.sourceModules)
                        ? connection.sourceModules
                        : String(connection.sourceModules || '').split(',');
                    sourceIds.push(...configuredSources);
                });
            }

            const calendarModuleId = Number(this.idmodule);
            const modules = [...new Set(sourceIds
                .map(sourceId => Number(sourceId))
                .filter(sourceId => Number.isFinite(sourceId) && sourceId > 0 && sourceId !== calendarModuleId))];

            if (modules.length) {
                this.$store.dispatch('addReloadModule', { modules });
            }
        },

        handleExternalDragEnter(event) {
            const receiver = this.dropReceiver();
            if (!receiver.enabled) return;
            const envelope = envelopeFromDataTransfer(event.dataTransfer);
            this.externalDropHighlighted = envelope
                ? !!matchingConnection(receiver, envelope)
                : hasEngineDragType(event.dataTransfer);
        },

        handleExternalDragOver(event) {
            if (!this.externalDropHighlighted) this.handleExternalDragEnter(event);
        },

        handleExternalDragLeave(event) {
            if (event.currentTarget.contains(event.relatedTarget)) return;
            this.externalDropHighlighted = false;
        },

        receiveExternalEvent(info) {
            this.externalDropHighlighted = false;
            const envelope = normalizeEnvelope(info && info.event && info.event.extendedProps
                ? info.event.extendedProps.engineDrag
                : null);
            const connection = matchingConnection(this.dropReceiver(), envelope);

            const start = info && info.event ? info.event.start : null;
            const end = info && info.event ? info.event.end : null;
            const allDay = info && info.event ? info.event.allDay : false;

            // FullCalendar crée d'abord un événement temporaire pour un drop externe.
            // La création réelle reste confiée au formulaire moteur configuré.
            if (info && info.event && typeof info.event.remove === 'function') info.event.remove();

            if (!connection) {
                this.$toast.warning('Cet élément ne peut pas être déposé dans ce calendrier');
                return;
            }

            const dropContext = {
                start: start ? this.moment(start).format('YYYY-MM-DD HH:mm:ss') : '',
                end: end ? this.moment(end).format('YYYY-MM-DD HH:mm:ss') : '',
                allDay: allDay ? 1 : 0,
            };
            const fields = mappedDropFields(connection, envelope, dropContext);
            const page = connection.page || (this.params.vue && this.params.vue.newpage);
            if (!page) {
                this.$toast.error('Aucune page n’est configurée pour ce dépôt');
                return;
            }

            const isUpdate = connection.mode === 'update' && fields.id !== undefined && fields.id !== '';
            this.goTo({
                modalKey: this.modalKey,
                name: page,
                typeform: isUpdate ? 'edit' : 'new',
                type: 'modal',
                replace: { id: isUpdate ? fields.id : 'new', ...fields },
                paramDialog: { width: 1000 },
            });
            this.pendingSourceModuleReload = envelope.sourceModuleId;
            this.fromThisModule = true;
        },

        constructParams(selectInfo) {
            let allDay = (selectInfo.allDay) ? 1 : 0;
            let params = {}
            params['allday'] = selectInfo.allDay;
            // variables par défaut envoyé par le module
            this.params.vue.sendget.forEach((get)=> {

                switch(get['value']) {
                    case '[[start]]' :
                    params[get['key']] = this.moment(selectInfo.start).format('YYYY-MM-DD LT')
                        break;
                    case '[[end]]' :
                    params[get['key']] = this.moment(selectInfo.end).format('YYYY-MM-DD LT')
                        break;

                    case '[[allday]]' :
                    params[get['key']] = allDay
                        break;
                    default :
                    params[get['key']] = this.switchValue(get['type'],this.replaceBy({page:this.modalKey,text:get['value']}))
                }

            })
            //variable extérieures :
            for (var el in this.args) {
                params[el] = (isNaN(this.args[el])) ? this.args[el] : Number(this.args[el]) ;

            }

            params = {...params, ...this.defaultFilter}

            return params;
        },

        clearCalendarSelection(selectInfo) {
            const calendar = selectInfo && selectInfo.view && selectInfo.view.calendar
                ? selectInfo.view.calendar
                : this.calendarApi;

            if(calendar && typeof calendar.unselect === 'function') {
                calendar.unselect();
            }
        },

        hasNewRdvPage() {
            const pageName = this.params && this.params.vue ? this.params.vue.newpage : '';
            const pages = this.$store.getters.listAll || [];

            return !!pageName && pages.some(page => (
                page.name === pageName &&
                page.props &&
                page.props.typeform === 'new'
            ));
        },

        openNewRdvPage(selectInfo) {
            const params = this.constructParams(selectInfo);
            const opened = this.goTo({
                modalKey: this.modalKey,
                name: this.params.vue.newpage,
                typeform: 'new',
                type: 'modal',
                replace: params,
                paramDialog: {width: 1000}
            });

            if(opened === false) {
                this.clearCalendarSelection(selectInfo);
                return;
            }

            this.fromThisModule = true;
        },

        newRDV(selectInfo) {

            if(this.hasNewRdvPage()) {

        // si ce module est intégré dans une page de type form et que ce form on enregistre avant d'ajouter une ligne dans la table de ce module
        if (this.typePage=='new' || this.typePage=='edit') {

          // on enregistre le formulaire avant l'envoi sur la page d'édition de ce module' :
          this.validateForm({form:this.form,page:this.page,modalKey:this.modalKey,validate:1,
            ifNotValid:()=>{
              this.$toast.warning('Vérifiez certains champs non complétés',{position: "top-center",timeout: 3000});
              this.clearCalendarSelection(selectInfo);
            },
            callback:()=> {
                this.initArguments();
                this.openNewRdvPage(selectInfo);
            }
          })

        } else {
          // si ce module est dans une page, on envoi la page d'édition de la table de ce module
          this.openNewRdvPage(selectInfo);
        }

            } else {
                this.clearCalendarSelection(selectInfo);
            }

        },

        switchValue(type,value) {
            var val = value
            switch(type) {
                case 'number' :
                val = Number(value);
                break;
                case 'text' :
                val = value.toString();
                break;
                case 'bool' :
                val = (value=='false') ? false : true;
                break;
                case 'array' :
                //si la valeur provient d'un get multiple, on crée un array  (ex : pour un champ à choix multiple)
                var getA = value.split(',');
                var constructArray = []
                getA.forEach((v) => {
                    constructArray.push(parseInt(v))
                })
                val = (value=='false') ? [] : constructArray;
                break;
            }
            return val;
        },

        clickRDV(info) {
            // info.jsEvent.layerY est l'emplacement du click sur l'event. si il est en dessous des boutons d'actions, on affiche l'edition du RDV
            if(this.clickAction===false) {
                if(this.params.vue.editpage) {

                    //si c'est un event reccurent on transmet un params 
                    
                    var filter = {"id":info.event.id};
                    if(info.event.extendedProps.initialEventID) filter['reccurentevent'] = true;
                    filter = {...filter, ...this.defaultFilter}
                    this.goTo({modalKey:this.modalKey,name:this.params.vue.editpage,typeform:'edit',type:'modal',replace:filter,paramDialog:{width:1000}})
                    this.fromThisModule = true;
                } else {

                    if (confirm("la page d'édition de la table " + this.table + " n'est pas créée, voulez-vous la créer maintenant ? ")) {
                        // on créé la page d'édition à la volé
                        this.createNewPage({ name: 'edit' + this.table, type: 'form', table: this.table,url:'/interface/'+this.table+'/:id/edit' ,
                            callback:()=> {
                                this.params.vue.editpage = 'edit' + this.table
                                this.params.vue.newpage = 'new' + this.table
                            this.goTo({ modalKey:this.modalKey, name: 'new'+this.table,typeform:'new', type: 'modal', replace: { id:info.event.id }, paramDialog: {width:1000}})
                            this.fromThisModule = true;
                            }
                        });
                    //this.$toast.error('Page d\'édition non paramétrée');
                    }
                }

            }

        },

        endResize(el,passRecurr) {

            if(this.actionReccur(el, 'resize',passRecurr) ) return;
            

            this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,action:'resize',event:el.event,recurrence:passRecurr}}).then((resp) => {
                if(!resp.data.success) {
                    this.$toast.error(resp.data.message);
                }
                this.calendarApi.refetchEvents()
            })

        },

        cancelReccur() {
                this.choiceReccur = '';
                this.eventReccur = {};
                this.typeActionReccur = '';
                this.dialogReccur = false;

        },

        applyChangeReccur() {
            switch(this.typeActionReccur) {
                case 'drop' :

                    this.Drop(this.eventReccur,this.choiceReccur) 
                break;
                case 'resize' :

                    this.endResize(this.eventReccur,this.choiceReccur) 
                break;
                case 'delete' :

                    this.delEvent(this.eventReccur,this.choiceReccur)
                break;
            }
        this.cancelReccur()
        },

        actionReccur(el,type,passRecurr) {
             if(el.event.extendedProps.initialEventID && !passRecurr) {
                this.typeActionReccur = type
                this.eventReccur = el;
                this.dialogReccur = true;
                if (typeof el.revert === 'function') {
                    el.revert();
                }
                return true;
            }
            return false;
        },

        Drop(el,passRecurr) {

            if(this.actionReccur(el, 'drop',passRecurr)) return;

            this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,action:'drop',event:el.event,old:el.oldEvent,recurrence:passRecurr}}).then((resp) => {
                if(!resp.data.success) {
                    this.$toast.error(resp.data.message);
                } else {
                    this.reloadDropSourceModules()
                }
                this.calendarApi.refetchEvents()
            })

        },

        delEvent(el,passRecurr) {

            this.clickAction = true
            setTimeout(()=>{
                    this.clickAction = false
                },1000)
            if(this.actionReccur(el, 'delete',passRecurr)) return;

            if(confirm('Vous allez supprimer ce rendez-vous, confirmer ?')) {

            this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,action:'delete',event:el.event,recurrence:passRecurr}}).then((resp) => {
              if(resp.data.success) {
                if(resp.data.message) this.$toast.success(resp.data.message);
                el.event.remove();
                // pour mettre a jour tous le cal
                if(passRecurr) this.calendarApi.refetchEvents()
              } else {
                this.$toast.error(resp.data.message);
              }
            })
 
          }

        },

        callAction(action,event) {
            this.clickAction = true
                this.clickActions({args:event,action:action,idmodule:this.idmodule,modalKey:this.modalKey,page:this.page,selectedLines:false,
                success:(datas) => {
                    if(datas.message) this.$toast.success(datas.message);
                    this.calendarApi.refetchEvents()
                },
                whenlink:() => {
                    this.fromThisModule = true;
                }
                })

            setTimeout(()=>{
                this.clickAction = false
            },1000)

        },

        updateIsMobile() {
            if(typeof window === 'undefined') return;
            const next = window.innerWidth < 960;
            if(next === this.isMobile) return;
            this.isMobile = next;
            this.applyResponsiveOptions();
        },

        applyResponsiveOptions() {
            const toolbarRight = this.defaultToolbarRight;
            const toolbarLeft = this.isMobile
                ? (this.defaultToolbarLeft || '')
                    .split(/\s+/)
                    .filter(Boolean)
                    .filter(part => part !== 'today')
                    .join(' ')
                : this.defaultToolbarLeft;
            const toolbarCenter = this.isMobile ? '' : this.defaultToolbarCenter;
            if(this.calendarOptions && this.calendarOptions.headerToolbar) {
                this.$set(this.calendarOptions.headerToolbar, 'right', toolbarRight);
                this.$set(this.calendarOptions.headerToolbar, 'left', toolbarLeft);
                this.$set(this.calendarOptions.headerToolbar, 'center', toolbarCenter);
            }
            const targetView = this.initialView || 'timeGridWeek';
            this.$set(this.calendarOptions, 'initialView', targetView);
            if(this.calendarApi) {
                const currentType = this.calendarApi.view ? this.calendarApi.view.type : null;
                if(targetView && currentType !== targetView) {
                    this.calendarApi.changeView(targetView)
                }
            }
            if(this.params && this.params.vue) {
                const hoursbarValue = this.initialHoursbar === null ? !!this.params.vue.hoursbar : this.initialHoursbar;
                this.$set(this.params.vue, 'hoursbar', hoursbarValue);
            }
        },

        initArguments() {
            // permet de récupérer les "POST" pour voir si gotodate (ou autre) est défini
            this.args = this.$store.getters.specificPage(this.modalKey).params
            //permet de supplenter la vue par défaut du calendrier si le POST defaultFilter est crée
            this.defaultFilter = this.$store.getters.specificPage(this.modalKey).querys
        }

    },

        mounted() {
            this.calendarApi = this.$refs.fullCalendar.getApi()
            this.updateIsMobile()
            if(typeof window !== 'undefined') {
                window.addEventListener('resize', this.updateIsMobile)
            }
            this.applyResponsiveOptions()

            fetch("https://date.nager.at/api/v3/PublicHolidays/"+new Date().getFullYear()+"/fr")
            .then(response => response.json())
            .then(data => {
                const obj = {}
                data.forEach(item => {
                    obj[item.date] = item.localName || item.name
                })
            this.calendarOptions.dayCellClassNames = (arg) => {
                const dd = this.moment(arg.date).format('YYYY-MM-DD')
            if (obj[dd]) {
                return ['ferie']
            }
            return []
            }

            })
            .catch(error => {
                console.error('Erreur lors de la récupération des jours fériés:', error)
            })

            this.syncInterval = setInterval(() => {
              if(this.$store.getters.getInactivState) {
                this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,onlysync:true}}).then((resp) => {
                  if(resp.data.syncAPI && resp.data.syncAPI.length) this.calendarApi.refetchEvents()
                })
              }
            }, 5 * 60 * 1000) // vérifie chaque 5 minute

        },

    beforeDestroy() {
        if(typeof window !== 'undefined') {
            window.removeEventListener('resize', this.updateIsMobile)
        }
        if(this.syncInterval) {
            clearInterval(this.syncInterval)
            this.syncInterval = null
        }
    },

    created() {

        this.initArguments();

    this.calendarOptions.initialDate = (this.defaultFilter['date']) ? this.defaultFilter['date'] : this.moment().format('YYYY-MM-DD');

    }

}
</script>

<style>

.fc-timegrid-event {
    padding:0px;
}
.fc-event-main {
    padding:0px;
    font-size:12px;
}
.fc-daygrid-event .fc-event-main-frame,
.fc-timegrid-event .fc-event-main-frame {
    display:flex;
    flex-direction:column;
    align-items:stretch;
}

div.fc-event-time {
    font-size:9px;
    background-color:grey;
    display:block;
    width:100%;
    text-align:left;
    float:none;
    padding:2px 4px;
    box-sizing:border-box;
}
/* permet sur la vue du mois, que les events ne dépassent pas en width.. */
.fc-daygrid-event {
    white-space:none;
}

.ferie {
  background-color: rgba(255, 0, 0, 0.1) !important;
}

.calendar-mobile .fc {
  --fc-timegrid-axis-width: 0px;
}

.calendar-mobile .fc-timegrid-axis,
.calendar-mobile .fc-timegrid-slot-label-frame,
.calendar-mobile .fc-timegrid-axis-frame {
  display: none !important;
}

</style>
